import { useEffect, type ReactNode } from 'react';

import { OptimizelyProvider, type ReactSDKClient } from '@optimizely/react-sdk';

import { useUserDataForFeatureFlag } from './useUserDataForFeatureFlag';

export { optimizelyClient } from './optimizelyClient';

/**
 * This provider component provides the Optimizely client to all child components via React context,
 * allowing them to access and use the Optimizely client for feature flag management.
 * The {children} prop is used to render any child components passed to this component.
 */
export const FeatureFlagsProvider = ({
  children,
  optimizelyClient,
}: {
  children?: ReactNode;
  optimizelyClient: ReactSDKClient;
}) => {
  const userData = useUserDataForFeatureFlag();

  useEffect(() => {
    if (!userData) return;
    optimizelyClient.setUser(userData);
  }, [optimizelyClient, userData]);

  return <OptimizelyProvider optimizely={optimizelyClient}>{children}</OptimizelyProvider>;
};
